export default "__VITE_ASSET__CNY4voNT__"